import { css } from "@compiled/react";

import { TypographyStyles } from "@/libraries/wpl/foundations/src/typography-styles";

import UniformText from "../../text/src/text";

import { Icon } from "./icon.tsx";

export interface UniformTextWithIconProps {
    text: string;
    style: TextStyleVariant;
    icon: string;
}

export type TextStyleVariant = "body-md" | "body-sm";

export const TEXT_STYLE_VARIANT_DEFAULT = "body-md" as TextStyleVariant;

export const UniformTextWithIcon = (props: UniformTextWithIconProps) => {
    const { text, style = TEXT_STYLE_VARIANT_DEFAULT, icon } = props;
    return (
        <TypographyStyles>
            <span css={wrapperCss}>
                <span data-testid="TextWithIcon-icon">
                    <Icon
                        name={icon}
                        size={style === "body-sm" ? "small" : "medium"}
                    />
                </span>
                <span
                    css={[
                        style === "body-sm" && smTextCss,
                        style === "body-md" && mdTextCss
                    ]}
                >
                    <UniformText text={text} style={style} />
                </span>
            </span>
        </TypographyStyles>
    );
};

const wrapperCss = css({
    display: "flex",
    gap: "8px"
});
const smTextCss = css({
    marginBlockStart: "1px"
});
const mdTextCss = css({
    marginBlockStart: "3px"
});

export default UniformTextWithIcon;
